import { useRef, useEffect, useState } from "react";
import DivContainer from "../../components/layouts/DivContainer";
import { usePatientData } from "../../context/PatientDataContext";
import PatientSearchInput from "./Components/PatientSearchInput";
import PatientInfoCards from "./Components/PatientInfoCards";
import ResultTable from "./Components/ResultTable";
import ActivityModal from "../../components/Modals/ActivityModal";
import PatientSearchModal from "../../components/Modals/SearchModal";
import GraficaModal from "../../components/Modals/GraficaModal";
import PregnancyModal from "../../components/Modals/PregnancyModal";
import PhoneModal from "../../components/Modals/PhoneModal";
import MailModal from "../../components/Modals/MailModal";
import AddressModal from "../../components/Modals/AddressModal";
import ResultModal from "../../components/Modals/ResultModal";
import ActiveGroupModal from "../../components/Modals/ActiveGroupModal";
import RutaMaternaModal from "../../components/Modals/RutaMaternaModal";
import FullScreenSpinner from "../../components/FullScreenSpinner";

const Home = () => {
  const {
    modalOpen,
    selectedActivity,
    modalTitle,
    unicId,
    tipoUnicId,
    tiposIdentificacion,
    setTipoUnicId,
    setUnicId,
    setSearchOrigin,
    patientData,
    yearOldData,
    resultData,
    GruposData,
    handleOpenModal,
    handleCloseModal,
    handleInputChange,
    handleKeyDown,
    handleClearAll,
    fetchPatientData,
    fetchPatientDataFromInput,
    pacientesModal,
    getPacienteExterno,
    exportPacienteExterno,
    canExportPaciente,
    showEmbarazoModal,
    setShowEmbarazoModal,
    fechaGestacion,
    setFechaGestacion,
    handleGuardarFechaGestacion,
    loading,
    loadingMessage,
    fetchTipoId
  } = usePatientData();

  const selectTipoIdRef = useRef(null);
  const inputUnicIdRef = useRef(null);

  const [modals, setModals] = useState({
    search: false,
    group: false,
    phone: false,
    mail: false,
    address: false,
    result: false,
    activeGroup: false,
    rutaMaterna: false,
  });

  const [selectedFromModal, setSelectedFromModal] = useState(false);
  const [selectedResult, setSelectedResult] = useState(null);

  const openModal = (name) => setModals((prev) => ({ ...prev, [name]: true }));
  const closeModal = (name) => setModals((prev) => ({ ...prev, [name]: false }));

  const handleSelectPatient = (patient) => {
    setSearchOrigin("search_modal");
    setTipoUnicId(patient.tipo);
    setUnicId(patient.id);
    setSelectedFromModal(true);
    openModal("search");
  };

  useEffect(() => {
    fetchTipoId();
  }, []);

  useEffect(() => {
    selectTipoIdRef.current?.focus();
  }, []);

  useEffect(() => {
    const handlePasteEvent = (e) => {
      inputUnicIdRef.current?.focus();
      setUnicId(e.detail);
    };
    
    const handleSearchMenu = () => openModal("search");
    const handleGroupMenu = () => openModal("activeGroup");

    window.addEventListener("paste-to-cedula", handlePasteEvent);
    window.addEventListener("open-search-modal", handleSearchMenu);
    window.addEventListener("open-group-modal", handleGroupMenu);
    
    return () => {
      window.removeEventListener("paste-to-cedula", handlePasteEvent);
      window.removeEventListener("open-search-modal", handleSearchMenu);
      window.removeEventListener("open-group-modal", handleGroupMenu);
    };
  }, [setUnicId]);

  useEffect(() => {
    if (selectedFromModal && tipoUnicId && unicId) {
      fetchPatientData();
      setSelectedFromModal(false);
    }
  }, [tipoUnicId, unicId, selectedFromModal]);

  return (
    <DivContainer>
      {/* Contenedor principal con Flexbox */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          overflow: "hidden",
        }}
      >
        {/* SECCIÓN 1: Search Input - Altura fija */}
        <div style={{ flexShrink: 0 }}>
          <PatientSearchInput
            selectTipoIdRef={selectTipoIdRef}
            inputUnicIdRef={inputUnicIdRef}
            tipoUnicId={tipoUnicId}
            setTipoUnicId={setTipoUnicId}
            unicId={unicId}
            setUnicId={setUnicId}
            tiposIdentificacion={tiposIdentificacion}
            handleInputChange={handleInputChange}
            handleKeyDown={handleKeyDown}
            handleClearAll={handleClearAll}
            fetchPatientData={fetchPatientDataFromInput}
            getPacienteExterno={getPacienteExterno}
            exportPacienteExterno={exportPacienteExterno}
            canExportPaciente={canExportPaciente}
            openSearchModal={() => openModal("search")}
            openModal={openModal}
          />
        </div>

        {/* SECCIÓN 2: Patient Info Cards - Altura dinámica pero sin crecer */}
        {patientData && (
          <div style={{ flexShrink: 0 }}>
            <PatientInfoCards
              patientData={patientData}
              yearOldData={yearOldData}
              resultData={resultData}
              GruposData={GruposData}
              openModal={openModal}
            />
          </div>
        )}

        {/* SECCIÓN 3: Results Table - Toma todo el espacio restante */}
        {resultData && (
          <div
            style={{
              flex: 1,
              minHeight: 0,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <ResultTable
              data={resultData}
              handleOpenModal={handleOpenModal}
              setSelectedResult={setSelectedResult}
              openModal={openModal}
            />
          </div>
        )}
      </div>

      {/* MODALES */}
      <ActivityModal
        isOpen={modalOpen}
        onClose={handleCloseModal}
        activity={selectedActivity}
        title={modalTitle}
      />
      <PatientSearchModal
        isOpen={modals.search}
        onClose={() => closeModal("search")}
        onSelect={handleSelectPatient}
        patients={pacientesModal}
      />
      <GraficaModal
        isOpen={modals.group}
        onClose={() => closeModal("group")}
        ident={unicId}
        tipoId={tipoUnicId}
      />
      <PregnancyModal
        isOpen={showEmbarazoModal}
        onClose={() => setShowEmbarazoModal(false)}
        fechaEmbarazo={fechaGestacion}
        setFechaEmbarazo={setFechaGestacion}
        onSave={handleGuardarFechaGestacion}
        patientUnicId={patientData?.Unic_ID}
      />
      <PhoneModal
        isOpen={modals.phone}
        onClose={() => closeModal("phone")}
        autoid={patientData?.autoid}
      />
      <MailModal
        isOpen={modals.mail}
        onClose={() => closeModal("mail")}
        id={patientData?.autoid}
      />
      <AddressModal
        isOpen={modals.address}
        onClose={() => closeModal("address")}
        id={patientData?.autoid}
      />
      <ResultModal
        isOpen={modals.result}
        onClose={() => closeModal("result")}
        data={selectedResult}
        id={patientData?.autoid}
        tipo_id={patientData?.Tipo_id}
        Identificacion={patientData?.Identificacion}
      />
      <ActiveGroupModal
        isOpen={modals.activeGroup}
        tipo_id={patientData?.Tipo_id}
        Identificacion={patientData?.Identificacion}
        onClose={() => closeModal("activeGroup")}
      />
      <RutaMaternaModal
        isOpen={modals.rutaMaterna}
        onClose={() => closeModal("rutaMaterna")}
        autoid={patientData?.autoid}
      />

      {/* LOADING SPINNER */}
      {loading && <FullScreenSpinner text={loadingMessage} />}
    </DivContainer>
  );
};

export default Home;
